import { useEffect } from "react";

/** Live donation page for the Twin City Veterans Bridge — TCVB Transition Program. */
export const DONATE_URL =
  "https://donate.giving.rocpos.com/twin-city-veterans-bridge-tcvb-transition-program";

/**
 * Donate — Public donation redirect (SPR-018 C-01 → live, SPR-021).
 *
 * Served at /donate (mobile "Donate" buttons + the web Give CTA open this). On
 * load it redirects to the external giving page; a manual "Continue to donate"
 * button is shown as a fallback if the auto-redirect is blocked/slow.
 */
export default function Donate() {
  useEffect(() => {
    const previous = document.title;
    document.title = "Donate — Twin City Silver Bullet";
    // Hand off to the secure external giving page.
    window.location.replace(DONATE_URL);
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <main data-testid="donate-page" className="min-h-screen bg-cream text-ink font-body">
      <section className="max-w-3xl mx-auto px-4 py-16 text-center">
        <p className="font-heading tracking-[0.3em] text-teal-deep text-sm">
          SUPPORT THE MISSION
        </p>
        <h1 className="font-display text-5xl text-charcoal uppercase mb-6">Donate</h1>

        <div className="mt-4 bg-cream-deep border-2 border-dashed border-aluminum-dark rounded-2xl p-8">
          <p className="font-display text-2xl text-rust uppercase mb-4">
            Redirecting to our donation page…
          </p>
          <p className="font-body text-ink/70 text-lg leading-relaxed mb-6">
            Taking you to our secure giving page for the Twin City Veterans Bridge —
            TCVB Transition Program. Every dollar helps build a bridge home for
            transitioning veterans.
          </p>
          <a
            href={DONATE_URL}
            data-testid="donate-link"
            className="inline-block bg-rust text-white font-heading tracking-widest px-6 py-3 rounded-xl shadow-[0_4px_0_#7f371e] hover:translate-y-0.5 hover:shadow-[0_2px_0_#7f371e] transition-all"
          >
            CONTINUE TO DONATE
          </a>
          <p className="font-body text-ink/50 text-xs mt-4">
            If you're not redirected automatically, use the button above.
          </p>
        </div>
      </section>
    </main>
  );
}
